import { ChangeDetectionStrategy, Component } from '@angular/core';
import { map as _map } from '@sama/micro-dash';
import { Observable } from 'rxjs';
import { map as rxMap } from 'rxjs/operators';
import { RejectionHistory } from '../../../team-apis/otterdam/task';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';

@Component({
  selector: 'h3-rejection-history',
  templateUrl: './rejection-history.component.html',
  styleUrls: ['./rejection-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RejectionHistoryComponent {
  perRound$: Observable<Array<RejectionHistory & { round: string }>>;

  constructor(store: TaskWorkspaceStore) {
    this.perRound$ = store('task')('_extras')('rejection_history').$.pipe(
      rxMap((history) =>
        _map(history, (h, round) => ({ ...h, round })).reverse(),
      ),
    );
  }
}
